import Vue from 'vue'
import Router from 'vue-router'
import {BlankLayout} from '@/layouts'
import blankLayout from "@/layouts/BlankLayout";

// hack router push callback
// [解决 vue-router跳转相同路径报错 ]
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 纯静态路由配置项
const constantRouterMap = [

    {
        path: '/',
        component: () => import('@/views/home/home'),
        meta: { title: '首页' }
    },
    {
        path: '/register',
        component: () => import('@/views/register/register'),
        meta: { title: '注册' }
    },
    {
        path: '/index',
        component: () => import('@/views/home/index'),
        meta: { title: '证书订购' }
    },
    {
        path: '/seal/index',
        component: () => import('@/views/seal/index'),
        meta: { title: '制图服务' }
    },
    {
        path: '/cost/index',
        component: () => import('@/views/cost/index'),
        meta: { title: '年费服务' }
    },
    {
        path: '/cost/check',
        component: () => import('@/views/cost/check.vue'),
        meta: { title: '检测证书' }
    },
    {
        path: '/home',
        component: () => import('@/views/home/home'),
        meta: { title: '首页1' }
    },
    {
        path: '/stampui',
        component: () => import('@/views/stampui/stampui.vue'),
        meta: { title: '制图服务' }
    },
    {
        path: '/login',
        component: () => import('@/views/user/login'),
        meta: { title: '登录' }
    },
    {
        path: '/orderlist',
        component: () => import('@/views/user/orderlist'),
        meta: { title: '订单列表' }
    },
    {
        path: '/userinfo',
        component: () => import('@/views/user/userinfo'),
        meta: { title: '用户信息' }
    },
    {
        path:'/modify',
        component: () => import('@/views/modify/modify'),
        meta: { title: '忘记密码' }
    }
]

export default new Router({
    // mode: 'history',
    routes: constantRouterMap
})
